import type { MembershipRequestFormData } from '#shared/types/MembershipRequest'
import type { SkillFormData } from '#shared/types/Skill'

import { SkillType } from '#shared/types/Skill'
import { isDate } from '@/validators/isDate'
import { isInDateRange } from '@/validators/isInDateRange'
import { isURL } from '@/validators/isURL'
import { isURLVideo } from '@/validators/isURLVideo'
import { isEmail, isRequired, validate } from 'last-validator'

export function validateSkill(skill: SkillFormData) {
    const isEvent = skill.type === SkillType.event
    const isStudyOpportunity = skill.type === SkillType.studyOpportunity

    return validate<SkillFormData>(skill, {
        title: [isRequired()],
        topics: [isRequired()],
        startDate: isEvent ? [isRequired(), isDate, isInDateRange] : [],
        studyLink: isStudyOpportunity ? [isURL] : [],
        contentURL: [isURLVideo]
    })
}

export function validateMembershipRequest(membershipRequest: MembershipRequestFormData) {
    return validate<MembershipRequestFormData>(membershipRequest, {
        email: [isRequired(), isEmail()],
        phone: [isRequired()],
        experienceLevel: [isRequired()],
        seniorityLevel: [isRequired()],
        joinMotivation: [isRequired()]
    })
}

export function validateContentUrl(skill: SkillFormData) {
    return validate<SkillFormData>(skill, {
        contentURL: [isURLVideo]
    })
}

export function validateRecordingUrl(skill: SkillFormData) {
    return validate<SkillFormData>(skill, {
        recordingURL: [isURLVideo]
    })
}
